module.exports = __webpack_public_path__ + "media/luxury-2026/coastal-kitchen-960-d2f7e2da.jpg";